import React, {Component} from 'react';
import Chart from 'chart.js';
import Navbar from "../Navbar/Navbar";
import './Plots.css';
import {Redirect} from 'react-router-dom';

export default class Plots extends Component {
    state = {
        dataArr: [],
        labelsArr: [],
        chartLabel: localStorage.getItem('plotItem'),
        chartType: 'line',
        plotName: '',
        currentPlotName: 'Line',
        plotUnit: 'day',
        currentPlotUnit: 'Day'
    };

    renderPlot = () => {
        this.chart = new Chart(this.canvasRef.current, {
            type: this.state.chartType,
            data: {
                labels: this.state.labelsArr,
                datasets: [{
                    fill: false,
                    label: this.state.chartLabel,
                    data: this.state.dataArr,
                    backgroundColor: ['blue', 'green', 'red', 'yellow', 'black', 'pink', 'rgba(199, 140, 77, 1)', 'rgba(129, 45, 143, 0.96)'],
                    borderColor: ['blue', 'green', 'red', 'yellow', 'black', 'pink', 'rgba(199, 140, 77, 1)', 'rgba(129, 45, 143, 0.96)'],
                    borderWidth: 3
                }]
            },
            options: {
                scales: {
                    xAxes: [
                        {
                            type: 'time',
                            time: {
                                unit: this.state.plotUnit
                            }
                        }
                    ],
                    yAxes: [{
                        ticks: {
                            beginAtZero: false,
                        },
                        scaleLabel: {
                            display: true,
                            labelString: 'Temperature'
                        }
                    }]
                }
            }
        });
    };

    constructor(props) {
        super(props);
        this.canvasRef = React.createRef();
        this.chart = undefined;

    }

    componentDidMount() {
        document.title = 'Plot';
        this.setState({plotName: localStorage.getItem('plotItem')});
        this.renderPlot();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

    }

    downIt = () => {

        fetch(`http://iotjokebase.herokuapp.com/getplotdata?uuidMine=${localStorage.getItem('uuid')}&plotname=${this.state.plotName}`).then(res => {
            // console.log(res.body);
            res.json().then(respjson => {
                // console.log(this.chart.data);
                // this.chart.data.labels = [];
                // this.chart.data.datasets[0].data = [];
                let dataMyArr = [];
                let labelsMyArr = [];
                for (let i = 0; i < respjson.length; i++) {
                    labelsMyArr.push(new Date(respjson[i].PLOTX));
                    dataMyArr.push(Number(respjson[i].PLOTY));
                }
                this.chart.destroy();
                this.setState({dataArr: dataMyArr, labelsArr: labelsMyArr});
                setTimeout(() => {
                    this.renderPlot()
                }, 100);
            }).catch(respjsonErr => {
                console.log('JSON Error : ' + respjsonErr.message);
            });
        }).catch(err => {
            console.log('Fetch Error : ' + err.message);
        });

        // this.setState({dataArr: [0, 19, 3, 5, 2, 3]});

        // setTimeout(()=>{this.updateChart()},50);

    };

    checkMobile=()=>{
        // window.mobilecheck = function() {
        //     let check = false;
        //     (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
        //     return check;
        // };
            return false;
    };

    redirectToLogin = () => {
        if (localStorage.getItem('uuid') === 'undefined' || localStorage.getItem('uuid') === null) {
            return (<Redirect to='/'/>);
        }
    };

    render() {
        return (<div>
            {this.redirectToLogin()}
            <Navbar/>

            <div className='row'>
                <div className='col-md-6 col-md-2'>
                    <div className='showOptions'>
                        <div className="dropdown">
                            <button className="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton"
                                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                {this.state.currentPlotName}
                            </button>
                            <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                <p className="dropdown-item" onClick={() => {
                                    this.setState({chartType: 'line', currentPlotName: 'Line'})
                                }}>Line</p>
                                <p className="dropdown-item" onClick={() => {
                                    this.setState({chartType: 'bar', currentPlotName: 'Bar'})
                                }}>Bar</p>
                                <p className="dropdown-item" onClick={() => {
                                    this.setState({chartType: 'pie', currentPlotName: 'Pie'})
                                }}>Pie</p>
                                <p className="dropdown-item" onClick={() => {
                                    this.setState({chartType: 'doughnut', currentPlotName: 'Doughnut'})
                                }}>Doughnut</p>
                            </div>
                        </div>
                        <div className="dropdown">
                            <button className="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton"
                                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                {this.state.currentPlotUnit}
                            </button>
                            <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                <p className="dropdown-item" onClick={() => {
                                    this.setState({plotUnit: 'hour', currentPlotUnit: 'Hour'})
                                }}>Hour</p>
                                <p className="dropdown-item" onClick={() => {
                                    this.setState({plotUnit: 'day', currentPlotUnit: 'Day'})
                                }}>Day</p>
                                <p className="dropdown-item" onClick={() => {
                                    this.setState({plotUnit: 'week', currentPlotUnit: 'Week'})
                                }}>Week</p>
                                <p className="dropdown-item" onClick={() => {
                                    this.setState({plotUnit: 'month', currentPlotUnit: 'Month'})
                                }}>Month</p>
                            </div>
                        </div>

                        <button className='btn btn-outline-success' onClick={this.downIt}>Update</button>
                    </div>
                </div>
            </div>

            <div className='row'>
                <div className='col-md-12 col-md-4'>
                    <canvas width="auto" height="auto" ref={this.canvasRef}> </canvas>
                </div>
            </div>


            {
                this.checkMobile() ?
                <div className='row'>
                    <div className='col-md-12 col-md-4'>
                        <h3 style={{'color': 'gray'}}>Desktop Site Recommended</h3>
                    </div>
                </div>: null
            }
        </div>);

    }
}
